import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cuánto tiempo me tomará notar cambios?',
    a: 'Desde el primer capítulo recibirás herramientas para soltar una tarea hoy mismo. El alivio mental es casi inmediato.'
  }, {
    q: '¿Tengo que leerlo todo de una vez?',
    a: 'No. Está diseñado por capítulos cortos para mujeres que no tienen tiempo. Puedes leer 5 minutos al día y aplicar una sola cosa.'
  }, {
    q: '¿Mi familia se enojará conmigo si pongo límites?',
    a: 'Es posible que haya resistencia inicial, pero el libro te enseña cómo manejar esa transición de forma amorosa y firme.'
  }, {
    q: '¿Es un libro físico?',
    a: 'Es un producto digital (PDF) que recibes en tu correo al instante para que puedas empezar hoy mismo.'
  }];
  return <section className="space-y-16" data-id="element-22">
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} className="bg-[#8B9E7E]/10 p-8 md:p-10 rounded-2xl text-center relative" data-id="element-23">
        <span className="text-6xl text-[#8B9E7E]/20 font-serif absolute top-4 left-4" data-id="element-24">
          "
        </span>
        <p className="text-lg md:text-xl text-[#3D2B1F] font-medium leading-relaxed italic relative z-10" data-id="element-25">
          En los próximos 7 días, tu pecho se sentirá más ligero. No porque el
          mundo haya cambiado, sino porque habrás dejado de intentar sostenerlo
          tú sola. Sentirás, por primera vez en años, que el descanso no es un
          premio que debes ganar, sino un lugar al que puedes volver.
        </p>
      </motion.div>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-26">
        <h3 className="text-3xl font-bold text-[#3D2B1F] text-center mb-8 font-serif" data-id="element-27">
          Preguntas Frecuentes
        </h3>

        {faqs.map((faq, index) => <div key={index} className="border-b border-[#3D2B1F]/10 last:border-0" data-id="element-28">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full py-4 flex items-center justify-between text-left focus:outline-none group" data-id="element-29">
              <span className="font-bold text-[#3D2B1F] group-hover:text-[#C4704B] transition-colors" data-id="element-30">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-[#C4704B] transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-31" />
            </button>
            <AnimatePresence data-id="element-32">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="overflow-hidden" data-id="element-33">
                  <p className="pb-4 text-[#3D2B1F]/70 leading-relaxed" data-id="element-34">
                    {faq.a}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
}